export class WorkitemItemDetailInput{
    
   public crmUserId: number;
   public sessionToken: string;
   public workItemId:number;
   public emailAddress:string;
   public customerId:number;
   }